var map = {
	"./de/warrior-name.png": "PHQg",
	"./en/warrior-name.png": "690+",
	"./es/warrior-name.png": "lGjM",
	"./fr/warrior-name.png": "pEj2",
	"./ja/warrior-name.png": "cM9e",
	"./ko/warrior-name.png": "9tS2",
	"./pt/warrior-name.png": "4pZj",
	"./ru/warrior-name.png": "ORoM",
	"./th/warrior-name.png": "NAqD",
	"./zh-Hant/warrior-name.png": "zOVG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ERJU";